module.exports = __webpack_public_path__ + "static/media/Get Started Guide Squadded.1429f605.pdf";